import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sync-warning-dialog',
  standalone: true,
  imports: [NgIf, MatDialogModule, MatButtonModule, MatIconModule, FlexLayoutModule, FlexModule],
  template: `
    <div class="saving-content">
      <div style="display: flex; position: relative; width: 100%; top: -10px; justify-content: flex-end;">
        <mat-icon (click)="continue()" style="cursor: pointer;">close</mat-icon>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="38" viewBox="0 0 44 38" fill="none">
        <path d="M0 38H44L22 0L0 38ZM24 32H20V28H24V32ZM24 24H20V16H24V24Z" fill="url(#paint0_linear_2477_49)"/>
        <defs>
          <linearGradient id="paint0_linear_2477_49" x1="17.389" y1="11.0396" x2="51.9978" y2="34.0945" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F79009"/>
            <stop offset="1" stop-color="#D47800"/>
          </linearGradient>
        </defs>
      </svg>
      <label class="dialogHeader" style="padding-top: 28px;">Unsynced Meter Readings</label>
      <div>
        <label class="dialogSubheader" style="display: block; padding-bottom: 0px">
          You have <b>{{ data.count }}</b> unsynced meter<span *ngIf="data.count !== 1">s</span>.
        </label>

        <label class="dialogSubheader" style="display: block;">
          {{ data.message }}
        </label>
        <ul *ngIf="data.meters?.length">
          <li *ngFor="let meter of data.meters">
            {{ meter.fileName || meter.filename }}
          </li>
        </ul>

        <p class="warning" *ngIf="data.from === 'header'">
          ** By clicking <b>Continue</b>, unsynced meter data will be lost 
          and replaced by the current data on the central system.
        </p>

        <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="8" style="padding-left: 0px; padding-right: 0px;">
          <button mat-flat-button style="width: 100%;" (click)="sync()">SYNC NOW</button>
          <button *ngIf="data.from === 'header'" mat-flat-button color="warn" style="width: 100%;" (click)="continue()">Continue</button>
        </div>
      </div>
    </div>
  `, 
  styles: [`
    ::ng-deep .mdc-dialog--open .mat-mdc-dialog-surface, .mdc-dialog--closing .mat-mdc-dialog-surface {
      transform: none;
      background: none !important;
    }
    /* Content Styles */
    .saving-content,
    .message-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 36px 24px 36px 24px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      max-width: 320px;
      margin: 1rem;
    }

    .saving-content h3,
    .message-content h3 {
      margin: 1rem 0 0.5rem 0;
      color: #333;
      font-weight: 500;
    }

    .saving-content p,
    .message-content p {
      margin: 0 0 1rem 0;
      color: #666;
      font-size: 0.9rem;
    }
    .warning {
      color: #e53935 !important;
      font-weight: 500;
    }
  `]
})
export class SyncWarningDialog {

  constructor(
    private dialogRef: MatDialogRef<SyncWarningDialog>, 
    private router: Router, 
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Close dialog immediately if on login page
    if (this.router.url.includes('login')) {
      this.dialogRef.close();
    }
  }

  sync() {
    this.dialogRef.close('sync');
  }

  continue() {
    this.dialogRef.close('continue');
  }
}